
<div class="banner_header">
    <div class="row" style="margin: 0px;">
        <div class="col-md-6">
            <h2>Exam Fees</h2>
        </div>
        <div class="col-md-6 align-right">
            <button *ngIf="bool_logout" class="btn-white" (click)="logout()">Log Out</button>
        </div>
    </div>

</div>

<!--Content Start-->
<section class="section_box_one">
    <div class="container">
        <h2>CTS CBT Main Exam AITT-2022 Fee Payment link </h2>
        
    </div>
</section>
<!--Content End-->

<div class="container payment_cls">


<router-outlet></router-outlet>








</div>


